var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.044 12.57V5.011l6.543 3.79-6.543 3.769zm14.578-9.836A3.15 3.15 0 0 0 22.406.518C20.44 0 12.57 0 12.57 0S4.7 0 2.734.518A3.15 3.15 0 0 0 .518 2.734C0 4.7 0 8.78 0 8.78s0 4.1.518 6.047a3.15 3.15 0 0 0 2.216 2.216c1.967.518 9.836.518 9.836.518s7.87 0 9.836-.518a3.15 3.15 0 0 0 2.216-2.216c.518-1.967.518-6.047.518-6.047s0-4.08-.518-6.046z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4a970e4062bc37543441f1747eec6a15.svg";
export { ForwardRef as ReactComponent };